<section class="table-page__card envio-bsc" id="envio-bsc" aria-labelledby="envio-bsc-titulo envio-bsc-titulo-vacio"
         [attr.aria-busy]="loading">
  <!-- ============================ Nada elegido ============================ -->
  <div class="table-page__empty envio-bsc__vacio" *ngIf="estado === 'VACIO'">
    <span class="material-icons" aria-hidden="true">fact_check</span>
    <h2 id="envio-bsc-titulo-vacio" tabindex="-1">Detalle del envío</h2>
    <p>Elige un área de la lista para revisar su cierre.</p>
  </div>

  <ng-container *ngIf="estado !== 'VACIO'">
    <header class="envio-bsc__cabeza">
      <div class="envio-bsc__cabeza-texto">
        <h2 id="envio-bsc-titulo" tabindex="-1">{{ titulo }}</h2>
        <p *ngIf="subtitulo">{{ subtitulo }}</p>
      </div>
      <div class="envio-bsc__cabeza-lado">
        <span class="table-page__status-badge bsc-en-vencida" *ngIf="sinEnviar">
          <span class="material-icons" aria-hidden="true">event_busy</span>
          Sin enviar
        </span>
        <span class="table-page__status-badge" *ngIf="estatus && !sinEnviar" [ngClass]="estatus.clase">
          <span class="material-icons" aria-hidden="true">{{ estatus.icono }}</span>
          {{ estatus.texto }}
        </span>
        <a class="table-page__link" *ngIf="verTablero && idBscArea != null && estado === 'DATOS'"
           [routerLink]="[ruta.area, idBscArea]" [queryParams]="queryArea"
           [attr.aria-label]="'Ver el tablero de ' + nombreArea">Ver tablero del área</a>
      </div>
    </header>

    <output class="table-page__empty envio-bsc__estado" *ngIf="estado === 'CARGANDO'">
      <span class="material-icons" aria-hidden="true">hourglass_top</span>
      <p>Consultando el envío…</p>
    </output>

    <div class="table-page__empty envio-bsc__estado" *ngIf="estado === 'ERROR'">
      <span class="material-icons" aria-hidden="true">lock_outline</span>
      <p role="alert">{{ error }}</p>
      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="consultar(false)">
        <span class="material-icons" aria-hidden="true">refresh</span>
        Volver a consultar
      </button>
    </div>

    <ng-container *ngIf="estado === 'DATOS'">
      <div class="bsc-franja envio-bsc__franja" *ngIf="franja" [ngClass]="franja.clase">
        <span class="material-icons" aria-hidden="true">{{ franja.icono }}</span>
        <span>{{ franja.texto }}</span>
      </div>

      <!-- ============================ Alcance ============================ -->
      <div class="envio-bsc__cifras">
        <div class="envio-bsc__cifra" *ngFor="let c of cifras; trackBy: trackTexto" [ngClass]="c.clase">
          <span class="envio-bsc__cifra-nombre">{{ c.etiqueta }}</span>
          <strong>{{ c.valor }}</strong>
          <span class="envio-bsc__cifra-nota" *ngIf="c.nota">{{ c.nota }}</span>
        </div>
      </div>
      <p class="bsc-nota envio-bsc__nota-alcance">
        <span class="table-page__status-badge" *ngIf="semaforo" [ngClass]="semaforo.clase">
          <span class="material-icons" aria-hidden="true">{{ semaforo.icono }}</span>
          {{ semaforo.texto }}
        </span>
        {{ notaAlcance }}
      </p>

      <!-- ============================ KPIs del trimestre ============================ -->
      <section class="envio-bsc__bloque" aria-labelledby="envio-bsc-kpis">
        <h3 id="envio-bsc-kpis">KPIs de Q{{ q }}</h3>
        <p class="bsc-nota" *ngIf="indicadores.length === 0">La planeación no tiene KPIs activos.</p>
        <ul class="envio-bsc__indicadores" *ngIf="indicadores.length > 0">
          <li *ngFor="let f of indicadores; trackBy: trackIndicador" class="envio-bsc__indicador"
              [class.is-na]="!f.vigente" [class.is-bajo]="f.bajoMeta">
            <div class="envio-bsc__indicador-fila">
              <a class="envio-bsc__objetivo" [routerLink]="[ruta.kpi, f.idEjercicioKpi]" [queryParams]="queryKpi"
                 [title]="f.objetivo" [attr.aria-label]="'Ficha de ' + f.objetivo">
                <span class="material-icons envio-bsc__marca" aria-hidden="true" *ngIf="f.bajoMeta">error_outline</span>
                {{ f.objetivo }}
              </a>
              <div class="envio-bsc__barra" *ngIf="f.barra; else sinBarra">
                <div class="envio-bsc__pista" aria-hidden="true">
                  <i [ngClass]="f.barra.clase" [style.width.%]="f.barra.pista.ancho"></i>
                  <b class="bsc-raya" *ngIf="f.barra.pista.raya != null" [style.left.%]="f.barra.pista.raya"></b>
                </div>
                <span aria-hidden="true">{{ f.barra.texto }}</span>
                <span class="cdk-visually-hidden">{{ f.barra.accesible }}</span>
              </div>
              <ng-template #sinBarra>
                <span class="envio-bsc__sin-barra">{{ f.vigente ? "Sin avance" : f.nota }}</span>
              </ng-template>
              <button type="button" class="envio-bsc__abrir" [attr.aria-expanded]="abiertos.has(f.idEjercicioKpi)"
                      [attr.aria-controls]="'envio-bsc-ev-' + f.idEjercicioKpi" [attr.aria-label]="f.etiquetaAbrir"
                      (click)="alternaEvidencia(f)">
                <span class="material-icons" aria-hidden="true">
                  {{ abiertos.has(f.idEjercicioKpi) ? "expand_less" : "expand_more" }}
                </span>
              </button>
            </div>

            <div class="envio-bsc__evidencia" [id]="'envio-bsc-ev-' + f.idEjercicioKpi"
                 *ngIf="abiertos.has(f.idEjercicioKpi)">
              <p class="envio-bsc__avance">{{ f.avance }}</p>
              <ol class="envio-bsc__meses">
                <li *ngFor="let m of f.meses; trackBy: trackMes" class="envio-bsc__mes">
                  <div class="envio-bsc__mes-cabeza">
                    <strong>{{ m.nombre }}</strong>
                    <span class="table-page__status-badge" *ngIf="m.estado && (m.capturado || m.estado.valor !== 'BLOQUEADO')"
                          [ngClass]="m.estado.clase">{{ m.estado.texto }}</span>
                    <span class="envio-bsc__capturo" *ngIf="m.capturo">{{ m.capturo }}</span>
                  </div>
                  <ng-container *ngIf="m.capturado; else mesVacio">
                    <p *ngIf="m.actividad"><span class="envio-bsc__rotulo">Actividad:</span> {{ m.actividad }}</p>
                    <p *ngIf="m.evidencia"><span class="envio-bsc__rotulo">Evidencia:</span> {{ m.evidencia }}</p>
                  </ng-container>
                  <ng-template #mesVacio><p class="envio-bsc__mes-vacio" *ngIf="m.vacio">{{ m.vacio }}</p></ng-template>
                </li>
              </ol>
              <p *ngIf="f.recursos"><span class="envio-bsc__rotulo">Recursos:</span> {{ f.recursos }}</p>
              <p *ngIf="f.comentario"><span class="envio-bsc__rotulo">Comentario del avance:</span> {{ f.comentario }}</p>
            </div>
          </li>
        </ul>
        <p class="bsc-nota">
          Acumulado real del año al cierre de Q{{ q }} (columna L del FOR-011); la raya marca lo programado.
        </p>
      </section>

      <!-- ============================ Bajo lo programado ============================ -->
      <div class="bsc-mensajes bsc-mensajes--aviso envio-bsc__mensajes" *ngIf="bajoMeta.length > 0">
        <h3>
          <span class="material-icons" aria-hidden="true">error_outline</span>
          {{ bajoMeta.length === 1 ? "1 KPI queda" : bajoMeta.length + " KPIs quedan" }} por debajo de lo programado
        </h3>
        <ul>
          <li *ngFor="let b of bajoMeta; trackBy: trackTexto"><strong>{{ b.objetivo }}</strong>: {{ b.texto }}</li>
        </ul>
      </div>

      <!-- ============================ Comentario del envío ============================ -->
      <section class="envio-bsc__bloque" aria-labelledby="envio-bsc-comentario"
               *ngIf="trimestre?.fechaEnvio || comentarioEnvio">
        <h3 id="envio-bsc-comentario">Comentario del envío</h3>
        <blockquote class="envio-bsc__cita" *ngIf="comentarioEnvio; else sinComentario">{{ comentarioEnvio }}</blockquote>
        <ng-template #sinComentario>
          <p class="bsc-nota">El área lo envió sin comentario.</p>
        </ng-template>
      </section>

      <div class="bsc-mensajes bsc-mensajes--aviso envio-bsc__mensajes" *ngIf="avisos.length > 0">
        <h3>
          <span class="material-icons" aria-hidden="true">info</span>
          Para tomar en cuenta
        </h3>
        <ul>
          <li *ngFor="let a of avisos; trackBy: trackTexto">{{ a }}</li>
        </ul>
      </div>

      <!-- ============================ Acciones ============================ -->
      <section class="envio-bsc__acciones" aria-label="Acciones de Dirección" *ngIf="acciones.modo || errorAccion">
        <p class="bsc-nota envio-bsc__por-que" *ngIf="acciones.nota">
          <span class="material-icons" aria-hidden="true">info</span>
          {{ acciones.nota }}
        </p>

        <ng-container *ngIf="acciones.visibles">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic" *ngIf="pideComentario">
            <mat-label>{{ etiquetaComentario }}</mat-label>
            <textarea matInput [attr.aria-label]="etiquetaComentario" id="envio-bsc-comentario-area" rows="3" [maxlength]="largoComentario"
                      [(ngModel)]="comentario" [disabled]="loading" (ngModelChange)="errorAccion = ''"></textarea>
            <mat-hint>{{ ayudaComentario }}</mat-hint>
            <mat-hint align="end">{{ comentario.length }}/{{ largoComentario }}</mat-hint>
          </mat-form-field>

          <p class="bsc-nota envio-bsc__por-que" *ngIf="acciones.porQueNoAutoriza" id="envio-bsc-propio">
            <span class="material-icons" aria-hidden="true">person_off</span>
            {{ acciones.porQueNoAutoriza }}
          </p>
          <p class="bsc-nota envio-bsc__por-que" *ngIf="acciones.porQueNoReabre" id="envio-bsc-no-reabre">
            <span class="material-icons" aria-hidden="true">block</span>
            {{ acciones.porQueNoReabre }}
          </p>
          <p class="bsc-nota envio-bsc__por-que" *ngIf="!tienePin && pideComentario">
            <span class="material-icons" aria-hidden="true">key</span>
            <span>
              Aún no defines tu PIN de autorización: se define una sola vez en
              <a class="table-page__link" [href]="rutaAjustes" target="_blank" rel="noopener">Ajustes</a>.
            </span>
          </p>

          <div class="envio-bsc__botones">
            <ng-container *ngIf="acciones.modo === 'RESOLVER'">
              <button type="button" mat-raised-button
                      class="btn table-page__icon-btn table-page__icon-btn--secondary envio-bsc__regresar"
                      [disabled]="loading" (click)="regresar()">
                <span class="material-icons" aria-hidden="true">undo</span>
                Regresar con comentarios
              </button>
              <button type="button" mat-raised-button class="btn table-page__primary-btn envio-bsc__autorizar"
                      [disabled]="loading || !acciones.autorizar"
                      [attr.aria-describedby]="acciones.porQueNoAutoriza ? 'envio-bsc-propio' : null"
                      (click)="autorizar()">
                <span class="material-icons" aria-hidden="true">verified</span>
                Autorizar Q{{ q }}
              </button>
            </ng-container>
            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
                    *ngIf="acciones.modo === 'REABRIR'" [disabled]="loading || !acciones.reabrir"
                    [attr.aria-describedby]="acciones.porQueNoReabre ? 'envio-bsc-no-reabre' : null"
                    (click)="reabrir()">
              <span class="material-icons" aria-hidden="true">lock_open</span>
              Reabrir Q{{ q }}
            </button>
          </div>
        </ng-container>

        <p class="envio-bsc__error-accion" *ngIf="errorAccion" role="alert" tabindex="-1">{{ errorAccion }}</p>
      </section>

      <!-- ============================ Bitácora ============================ -->
      <section class="envio-bsc__bloque envio-bsc__bitacora" aria-labelledby="envio-bsc-bitacora">
        <h3 id="envio-bsc-bitacora">Bitácora de Q{{ q }}</h3>
        <ol *ngIf="movimientos.length > 0">
          <li *ngFor="let m of movimientosVisibles; trackBy: trackMovimiento">
            <time>{{ m.cuando }}</time>
            <span><strong>{{ m.accion }}</strong> · {{ m.quien }}</span>
            <span class="envio-bsc__bitacora-detalle" *ngIf="m.detalle">{{ m.detalle }}</span>
          </li>
        </ol>
        <p class="bsc-nota" *ngIf="movimientos.length === 0">Sin movimientos en el trimestre.</p>
        <button type="button" class="table-page__link envio-bsc__mas" *ngIf="movimientos.length > movimientosVisibles.length"
                (click)="verTodaBitacora = true">
          Ver toda la bitácora ({{ movimientos.length }})
        </button>
      </section>
    </ng-container>
  </ng-container>
</section>
